import { sluggify } from "../string/sluggify";

export const optionify = (opts: string[]) => {
  return opts.map((opt) => ({ label: opt, value: sluggify(opt) }));
};
